module.exports = __webpack_public_path__ + "static/ActaHeadline-BookItalic-808aebb886754817ddc3a0d4c5c68dbe.woff";